var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45304 13.6004C5.986 13.2323 5.56407 12.8104 5.19604 12.3434L1.16804 16.3714C1.00664 16.5391 0.917498 16.7635 0.919752 16.9963C0.922007 17.2291 1.01548 17.4517 1.18009 17.6163C1.34471 17.7809 1.56732 17.8744 1.8001 17.8767C2.03288 17.8789 2.25727 17.7898 2.42504 17.6284L6.45304 13.6004ZM11.13 15.2214C13.134 15.2214 15.0559 14.4253 16.4729 13.0083C17.89 11.5912 18.686 9.66935 18.686 7.66537C18.686 5.6614 17.89 3.7395 16.4729 2.32248C15.0559 0.905451 13.134 0.109375 11.13 0.109375C9.12606 0.109375 7.20416 0.905451 5.78714 2.32248C4.37011 3.7395 3.57404 5.6614 3.57404 7.66537C3.57404 9.66935 4.37011 11.5912 5.78714 13.0083C7.20416 14.4253 9.12606 15.2214 11.13 15.2214ZM11.13 13.4434C9.59761 13.4434 8.12796 12.8346 7.04437 11.751C5.96079 10.6675 5.35204 9.1978 5.35204 7.66537C5.35204 6.13295 5.96079 4.6633 7.04437 3.57971C8.12796 2.49613 9.59761 1.88737 11.13 1.88737C12.6625 1.88737 14.1321 2.49613 15.2157 3.57971C16.2993 4.6633 16.908 6.13295 16.908 7.66537C16.908 9.1978 16.2993 10.6675 15.2157 11.751C14.1321 12.8346 12.6625 13.4434 11.13 13.4434Z",
    fill: "#283476"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9391884beea3e9347fe660a8a2770402.svg";
export { ForwardRef as ReactComponent };